import React from 'react';
import { InjectedRouter } from 'react-router';
// @ts-ignore
import Config from 'Config';
import Cookies from 'lib/Cookies';
import GTMScript from 'components/GTMScript';
import CoachingConstants from 'coaching/CoachingConstants';
import CoachingSelfServeIntroView from 'coaching/components/CoachingSelfServeView/CoachingSelfServeIntroView';
import CoachingIsolatedViewHeader from 'coaching/components/CoachingIsolatedViewHeader';

type Props = {
  router: InjectedRouter;
};

export default function CoachingIntroContainer(props: Props) {
  const hasOptOutExperiment = Config.Environment.COACHING_OPT_OUT_ENABLED === 'true';

  return (
    <div className="CoachingIsolatedView">
      <GTMScript />
      <CoachingIsolatedViewHeader />
      <CoachingSelfServeIntroView
        onContinue={() => {
          Cookies.set(CoachingConstants.IS_INTENDED_COACHING_USER_COOKIE, 'true', { expires: 1 });
          props.router.push(CoachingConstants.COACHING_PURCHASE_REVIEW_ROUTE);
        }}
        hasOptOutExperiment={hasOptOutExperiment}
      />
    </div>
  );
}
